module.exports = __webpack_public_path__ + "img/menuPasteWhite.52e2d54d.svg";